'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const NewSlimChatLinear = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M4.295 1.333h7.413a3.067 3.067 0 0 1 2.96 3.16V8.84A3.067 3.067 0 0 1 11.682 12H5.335c-.44.01-.856.197-1.153.52l-1.58 1.687a.72.72 0 0 1-.52.233.767.767 0 0 1-.747-.793V4.493a3.067 3.067 0 0 1 2.96-3.16M11.708 11a2.067 2.067 0 0 0 1.96-2.16V4.493a2.067 2.067 0 0 0-1.96-2.16H4.295a2.067 2.067 0 0 0-1.96 2.16v8.534l1.087-1.187A2.67 2.67 0 0 1 5.335 11z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                d: "M5.502 5.833h3.333a.5.5 0 1 0 0-1H5.502a.5.5 0 1 0 0 1M10.502 7.5h-5a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1"
            })
        ]
    })));

export { NewSlimChatLinear, NewSlimChatLinear as default };
//# sourceMappingURL=NewSlimChatLinear.js.map
